import React from 'react';

const colorMap = {
  green:   { iconText: 'text-green-700',   iconBg: 'bg-green-50'   },
  emerald: { iconText: 'text-emerald-700', iconBg: 'bg-emerald-50' },
  teal:    { iconText: 'text-teal-700',    iconBg: 'bg-teal-50'    },
  amber:   { iconText: 'text-amber-700',   iconBg: 'bg-amber-50'   },
};

const StatCard = ({ title, value, icon: Icon, color = 'green', isLive = false }) => {
  const c = colorMap[color] || colorMap.green;

  return (
    <div className="bg-white rounded-2xl border border-slate-100 shadow-sm hover:shadow-md transition-all duration-200 p-5 flex flex-col gap-3">
      {/* Title + Icon */}
      <div className="flex items-center justify-between">
        <p className="text-xs font-semibold text-slate-500 uppercase tracking-wide">{title}</p>
        <div className={`p-2 rounded-xl ${c.iconBg}`}>
          <Icon className={`w-4 h-4 ${c.iconText}`} />
        </div>
      </div>

      {/* Real value from API */}
      <h3 className="text-3xl font-extrabold text-slate-900 font-display leading-none">{value}</h3>

      {/* Live indicator for chat only */}
      {isLive ? (
        <div className="flex items-center gap-1.5">
          <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
          <span className="text-xs font-semibold text-green-700">Live</span>
          <span className="text-xs text-slate-400">Socket.io channels</span>
        </div>
      ) : (
        <div className="h-4" /> 
      )}
    </div>
  );
};

export default StatCard;
